import React from 'react';

/** Skeleton rows for table loading states */
export default function LoadingRows({ rows = 5, cols = 6 }) {
  return Array.from({ length: rows }).map((_, r) => (
    <tr key={r} className="list-stripe-row">
      {Array.from({ length: cols }).map((__, c) => (
        <td key={c} className="px-4 py-4">
          <div className="h-3 rounded-ds bg-line/80 animate-pulse max-w-[80%]" />
        </td>
      ))}
    </tr>
  ));
}
